import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION6: PdfComponent = {
  type: 'section',
  id: 's3s6',
  title: '6. Deposit Limits',
  content: [
    {
      type: 'bulletList',
      id: 's3s6bullets',
      bulletType: 'dot',
      content: [
        {
          copy: {
            type: 'altText',
            id: 's3s6minpct',
            content: ['Minimum Deposit %', ': 0%'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's3s6minval',
            content: ['Minimum Deposit Value', ': £0.00'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's3s6maxpct',
            content: ['Maximum Deposit %', ': 50%'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's3s6maxval',
            content: ['Maximum Deposit Value', ': £50,000.00'],
          },
        },
      ],
    },
  ],
};
